<template>
  <svg :width="size" :height="size" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <!-- Crossed hockey sticks -->
    <line x1="4" y1="28" x2="22" y2="4" :stroke="color" stroke-width="3" stroke-linecap="round" />
    <line x1="28" y1="28" x2="10" y2="4" :stroke="color" stroke-width="3" stroke-linecap="round" />
    <!-- Stick blade left -->
    <path d="M4 28l-1 1.5c-.3.5 0 1 .5 1h3l-1-2.5" :fill="color" />
    <!-- Stick blade right -->
    <path d="M28 28l1 1.5c.3.5 0 1-.5 1h-3l1-2.5" :fill="color" />
    <!-- Puck -->
    <ellipse cx="16" cy="22" rx="4" ry="2" :fill="color" opacity="0.6" />
  </svg>
</template>
<script setup lang="ts">
withDefaults(defineProps<{ size?: number; color?: string }>(), {
  size: 28,
  color: '#CC0000',
});
</script>
